import { UseToastOptions, useToast } from '@chakra-ui/react';

export type ActionToastStatus = 'success' | 'error' | 'warning' | 'info';

export type ActionToastInput = Omit<UseToastOptions, 'status' | 'title' | 'description'> & {
  status: ActionToastStatus;
  title: string;
  description?: string;
};

let toastSequence = 0;

const durations: Record<ActionToastStatus, number> = {
  success: 3500,
  info: 4500,
  warning: 6000,
  error: 8000,
};

const safeDescription = (description?: string) => {
  if (!description) return undefined;
  return description.replace(/https?:\/\/\S+|Bearer\s+\S+|token[=:]\s*\S+/gi, '').slice(0, 240);
};

export function useActionToast() {
  const toast = useToast();

  return ({ status, title, description, id }: ActionToastInput) => {
    toastSequence += 1;
    const toastId = id || `${status}-${title}-${Date.now()}-${toastSequence}`;
    if (id && toast.isActive(toastId)) return;

    const options: UseToastOptions = {
      id: toastId,
      title,
      description: safeDescription(description),
      status,
      duration: durations[status],
      isClosable: true,
      position: 'top-right',
      variant: 'left-accent',
    };
    toast(options);
  };
}

export function useFormValidationToast() {
  const actionToast = useActionToast();
  return () => {
    actionToast({
      status: 'error',
      title: 'Revise o formulário',
      description: 'Corrija os campos indicados antes de enviar.',
      id: 'form-validation-error',
    });
  };
}
